/* eslint-disable react/prop-types */
import { FormattedMessage } from 'react-intl';

import commonTranslations from 'shared/translations/overlay-common-translations';
import { getFullAccessActionName, FULL_ACCESS_ACTION_NAMES } from 'widget/ui-selectors/video-access';


/**
 * Is channel sign in to play button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
export function isVisible({ channel, video }) {
  return getFullAccessActionName(channel, video) === FULL_ACCESS_ACTION_NAMES.SIGN_IN;
}

/**
 * Channel sign in to play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.translation {Object} default is commonTranslations.playVideo
 * @return {React.Component}
 */
export default function renderSignInToWatchButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }

  const translation = props.translation || commonTranslations.playVideo;
  return <FormattedMessage {...translation} />;
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/video/sign-in-to-watch-button-text.js